import { render, staticRenderFns } from "./page-404.vue?vue&type=template&id=5722e3c7&scoped=true"
import script from "./page-404.vue?vue&type=script&lang=js"
export * from "./page-404.vue?vue&type=script&lang=js"
import style0 from "./page-404.vue?vue&type=style&index=0&id=5722e3c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722e3c7",
  null
  
)

export default component.exports